import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
const modules = [{
  emoji: '🕯️',
  number: 1,
  title: 'Introducción al Mundo de las Tabletas Aromáticas',
  topics: ['Qué son las tabletas aromáticas', 'Usos y aplicaciones', 'Diferencias con wax melts y aromatizantes sólidos', 'Herramientas y materiales básicos']
}, {
  emoji: '🧪',
  number: 2,
  title: 'Materias Primas y Materiales Profesionales',
  topics: ['Tipos de ceras y sus características', 'Fragancias y esencias aromáticas', 'Colorantes y aditivos', 'Cómo elegir insumos de calidad']
}, {
  emoji: '🌡️',
  number: 3,
  title: 'Proceso Correcto de Elaboración',
  topics: ['Preparación del espacio de trabajo', 'Control de temperaturas', 'Mezcla correcta de ingredientes', 'Vertido y desmolde profesional']
}, {
  emoji: '🎨',
  number: 4,
  title: 'Diseño y Estética de Tabletas',
  topics: ['Tabletas decorativas premium', 'Técnicas visuales y acabados profesionales', 'Inclusiones botánicas seguras', 'Creación de estilos únicos']
}, {
  emoji: '🌺',
  number: 5,
  title: 'Aromas y Formulación Aromática',
  topics: ['Cómo combinar fragancias', 'Intensidad y fijación del aroma', 'Creación de blends exclusivos', 'Aromas según ambientes y emociones']
}, {
  emoji: '🏠',
  number: 6,
  title: 'Tipos de Tabletas Aromáticas',
  topics: ['Para placares y cajones', 'Ambientales decorativas', 'Estacionales y temáticas', 'Tabletas de autor']
}, {
  emoji: '👶',
  number: 7,
  title: 'Tabletas Aromáticas para Bebés',
  topics: ['Seguridad aromática infantil', 'Aromas suaves y baby-safe', 'Ingredientes permitidos y prohibidos', 'Tabletas para habitación infantil', 'Productos para rutinas de descanso']
}, {
  emoji: '⚠️',
  number: 8,
  title: 'Errores Comunes y Soluciones',
  topics: ['Problemas frecuentes', 'Fallas en aroma o textura', 'Cómo corregir imperfecciones', 'Mejora del acabado final']
}, {
  emoji: '📦',
  number: 9,
  title: 'Conservación y Packaging',
  topics: ['Cómo prolongar el aroma', 'Almacenamiento correcto', 'Presentación profesional', 'Packaging atractivo y seguro']
}, {
  emoji: '💰',
  number: 10,
  title: 'Producción y Rentabilidad',
  topics: ['Organización de producción', 'Costeo del producto', 'Cálculo de precios', 'Producción eficiente']
}, {
  emoji: '🚀',
  number: 11,
  title: 'Creación de Marca Aromática',
  topics: ['Identidad de marca', 'Diferenciación en el mercado', 'Creación de colecciones', 'Posicionamiento del producto']
}, {
  emoji: '🛍️',
  number: 12,
  title: 'Venta y Escalabilidad del Negocio',
  topics: ['Cómo comenzar a vender', 'Canales de venta', 'Estrategias comerciales', 'Escalar tu emprendimiento artesanal']
}];
export function ModulesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-115">
      <div className="container mx-auto max-w-4xl" data-id="element-116">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-117">
          <div className="inline-block px-4 py-2 bg-gradient-to-r from-[#FFD6EC] to-[#FFB3E6] rounded-full mb-4" data-id="element-118">
            <span className="text-sm font-bold text-[#FF4DB8]" data-id="element-119">
              CONTENIDO DEL CURSO
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-120">
            12 módulos completos
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto" data-id="element-121">
            De principiante a experta: todo lo que necesitás para crear y vender
            tabletas aromáticas
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3" data-id="element-122">
          {modules.map((mod, index) => {
          const isOpen = openIndex === index;
          return <article key={index} className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white" data-id="element-123">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-pink-50/40 transition-colors duration-200" aria-expanded={isOpen} data-id="element-124">
                  <div className="flex items-center gap-4" data-id="element-125">
                    {/* Emoji + number badge */}
                    <div className="flex items-center gap-2 flex-shrink-0" data-id="element-126">
                      <span className="w-9 h-9 flex items-center justify-center rounded-xl text-sm font-extrabold text-white bg-gradient-to-br from-[#FF4DB8] to-[#FF6EC7] shadow-sm" aria-hidden="true" data-id="element-127">
                        {mod.number}
                      </span>
                      <span className="text-xl" aria-hidden="true" data-id="element-128">
                        {mod.emoji}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg font-bold text-gray-900 leading-snug" data-id="element-129">
                      Módulo {mod.number} — {mod.title}
                    </h3>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 text-[#FF4DB8] flex-shrink-0 ml-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-130" />
                </button>

                {/* Expandable content */}
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-131">
                  <div className="px-6 pb-6 pt-1" data-id="element-132">
                    <div className="border-t border-pink-100 pt-4" data-id="element-133">
                      <ul className="space-y-2" data-id="element-134">
                        {mod.topics.map((topic, tIndex) => <li key={tIndex} className="flex items-start gap-3" data-id="element-135">
                            <span className="w-5 h-5 rounded-full bg-gradient-to-br from-[#FFD6EC] to-[#FFB3E6] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-136">
                              <span className="w-2 h-2 rounded-full bg-[#FF4DB8] block" data-id="element-137" />
                            </span>
                            <span className="text-[#6B6B6B] text-sm md:text-base" data-id="element-138">
                              {topic}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>
              </article>;
        })}
        </div>

        {/* CTA Button */}
        <div className="mt-12 text-center" data-id="element-139">
          <p className="text-lg text-[#6B6B6B] mb-6 font-medium" data-id="element-140">
            Todo esto incluido en un solo pago
          </p>
          <a href={CART_URL} className="inline-block px-10 py-5 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] hover:from-[#FF6EC7] hover:to-[#FF4DB8] text-white font-bold text-lg rounded-2xl shadow-lg shadow-pink-500/20 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/30 hover:scale-105" data-id="element-141">
            Quiero acceder al curso completo
          </a>
          <p className="text-sm text-gray-500 mt-4" data-id="element-142">
            Acceso inmediato • Garantía 72hs • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}